import React, { useRef, useState } from 'react';
import { Button } from 'kenshin';
import {
  CloseOutlined,
  DownloadOutlined,
  DeleteOutlined,
  StarOutlined,
  RedoOutlined,
  PlayCircleOutlined,
  PauseCircleOutlined,
} from '@ant-design/icons';
import { getVideoCoverUrl } from '@/_util/util';
import './index.less';

const VideoPreview = ({ videoUrl, description, onClose }) => {
  const videoRef = useRef();
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      setDuration(videoRef.current.duration);
    }
  };

  const handleSeek = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;
    if (videoRef.current) {
      videoRef.current.currentTime = percent * duration;
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  const actionButtons = [
    { label: '重新生成', icon: <RedoOutlined />, action: () => {} },
    { label: '下载', icon: <DownloadOutlined />, action: () => {} },
    { label: '删除', icon: <DeleteOutlined />, action: () => {} },
    { label: '收录', icon: <StarOutlined />, action: () => {} },
  ];

  return (
    <div className="videoPreviewOverlay" onClick={onClose}>
      <div className="videoPreviewContent" onClick={(e) => e.stopPropagation()}>
        {/* 关闭按钮 */}
        <div className="closeBtn" onClick={onClose}>
          <CloseOutlined />
        </div>

        {/* 返回按钮 */}
        {/* <Button className="backBtn" onClick={onClose}>
          返回对话
        </Button> */}

        {/* 视频播放器 */}
        <div className="videoPlayer">
          <video
            ref={videoRef}
            src={videoUrl}
            className="videoElement"
            onTimeUpdate={handleTimeUpdate}
            onLoadedMetadata={handleLoadedMetadata}
          />
          {/* 播放按钮覆盖层 */}
          {!isPlaying && (
            <div className="playOverlay" onClick={handlePlayPause}>
              <PlayCircleOutlined style={{ fontSize: 64, color: '#fff' }} />
            </div>
          )}
          {/* 进度条 */}
          <div className="progressContainer" onClick={handleSeek}>
            <div
              className="progressBar"
              style={{ width: duration ? `${(currentTime / duration) * 100}%` : '0%' }}
            />
            <div className="timeDisplay">
              <span>{formatTime(currentTime)}</span>
              <span>/</span>
              <span>{formatTime(duration)}</span>
            </div>
          </div>
          {/* 播放/暂停按钮 */}
          <div className="playControls">
            {isPlaying ? (
              <PauseCircleOutlined onClick={handlePlayPause} />
            ) : (
              <PlayCircleOutlined onClick={handlePlayPause} />
            )}
          </div>
        </div>

        {/* 右侧操作区 */}
        <div className="sidePanel">
          {/* 缩略图 */}
          <div className="videoThumb">
            <img src={getVideoCoverUrl(videoUrl)} alt="视频封面" />
          </div>
          {description && (
            <div className="videoDesc">
              视频描述：{description}
            </div>
          )}

          {/* 操作按钮 */}
          <div className="actionButtons">
            {actionButtons.map((btn, idx) => (
              <Button
                key={idx}
                className="actionBtn"
                onClick={btn.action}
              >
                {btn.label}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPreview;
